import angular from 'angular';

export default function stickyThead(Utils, $compile, $window, $timeout) {
  'ngInject';

  return {
    scope: {
      stickyOffset: '<',
      offsetChangeBackoff: '<?',
      alwaysStick: '<',
      cloneShown: '=?',
    },
    compile(element) {
      const rawElementHTML = element[0].outerHTML;

      return {
        post($scope, $element) {
          const originalHeadersClientWidths = [];
          const throttledTranslateHeight = Utils.throttle(translateHeaderWidths, 2000);
          let cloneShown = false;
          let offset = null;
          let refreshDisabled = false;

          const cloneElement = angular.element(rawElementHTML);
          cloneElement
            .removeAttr('sticky-thead') // prevent infinite loop
            .removeAttr('sticky-scroll') // prevent infinite loop
            .addClass('ng-hide')
            .addClass('sticky-thead-clone')
            .css({
              width: `${$element[0].offsetWidth}px`,
            });

          cloneElement.find('tbody')?.remove();
          cloneElement.find('tfoot')?.remove();

          $element.after(cloneElement);
          $compile(cloneElement)($scope.$parent);

          $scope.$on('$destroy', () => {
            cloneElement.remove();
            angular.element($window).off('scroll', refresh);
          });

          angular.element($window).on('scroll', refresh);
          $scope.$watch(refresh);

          $element.on('scroll', () => translateScroll($element, cloneElement));
          cloneElement.on('scroll', () => translateScroll(cloneElement, $element));

          $scope.$$postDigest(() => translateScroll($element, cloneElement));

          refresh();

          function refresh() {
            throttledTranslateHeight($element, cloneElement);

            if (refreshDisabled) {
              return;
            }

            const oldShown = cloneShown;
            if (offset !== null && offset !== $scope.stickyOffset && $scope.offsetChangeBackoff) {
              offset = $scope.stickyOffset;
              refreshDisabled = true;
              $timeout(() => {
                refreshDisabled = false;
                refresh();
              }, $scope.offsetChangeBackoff);
              return;
            }

            offset = $scope.stickyOffset;

            const originalElementRect = $element[0].getBoundingClientRect();
            const cloneElementHeadRect = cloneElement[0]
              .querySelector('thead')
              .getBoundingClientRect();

            cloneElement.css({
              top: `${offset}px`,
              left: `${originalElementRect.left}px`,
              marginTop: `${Math.min(
                0,
                originalElementRect.bottom - (offset + cloneElementHeadRect.height)
              )}px`,
              height: `${$element.find('thead')[0]?.getBoundingClientRect().height}px`,
            });

            cloneShown = originalElementRect.top < offset || $scope.alwaysStick;
            $scope.cloneShown = cloneShown;

            if (cloneShown !== oldShown) {
              // the ng-hide class is manually toggled to maximize performance
              cloneElement[cloneShown ? 'removeClass' : 'addClass']('ng-hide');

              if (cloneShown) {
                translateScroll($element, cloneElement);
              }
            }
          }

          function translateScroll(fromElement, toElement) {
            toElement[0].scrollLeft = fromElement[0].scrollLeft;
            toElement[0].scrollTop = fromElement[0].scrollTop;

            cloneElement.find('[sticky-thead-anchor-left]').css({
              left: `${toElement[0].scrollLeft}px`,
            });

            cloneElement.find('[sticky-thead-anchor-right]').css({
              right: `-${toElement[0].scrollLeft}px`,
            });
          }

          function translateHeaderWidths(fromElement, toElement) {
            const original = Array.from($element.find('th'));
            const copy = toElement.find('th');
            const shouldUpdate =
              original.length !== originalHeadersClientWidths.length ||
              original.some((el, index) => el.clientWidth !== originalHeadersClientWidths[index]);

            if (shouldUpdate) {
              original.forEach((el, index) => {
                originalHeadersClientWidths.push(el.clientWidth);
                angular.element(copy[index]).css('min-width', `${el.clientWidth}px`);
              });
            }
          }
        },
      };
    },
  };
}
